import {
  filterNewlyInstalledDevices,

} from '@common/utils/helperFunctions'
import { useAuthStore } from '@store/auth.store'
import { AlertStatusComponent } from './Dashboard/AlertStatusComponent'
import { CurrentWaterUsageComponent } from './Dashboard/CurrentWaterUsageComponent'
import { DeviceStatusComponent } from './Dashboard/DeviceStatusComponent'
import { NewlyInstalledDevicesComponent } from './Dashboard/NewlyInstalledDevicesComponent'
import { useVisibleDevices } from '@data/device/device'
import { UserDeviceListComponent } from './Dashboard/UserDeviceListComponent'
import { useMemo } from 'react'
import { hasPermissions } from '@common/utils/validation/authValidators'
import { useActiveAlertsQuery } from '@data/alerts/alerts'

function HomeOld() {
  const permissions = useAuthStore((state) => state.permissions)
  const devices = useVisibleDevices()
  const { data: queue = [] } = useActiveAlertsQuery()
  const statusShow = hasPermissions(permissions, ['DASHBOARD:STATUS:VIEW'])
  const devicesShow = hasPermissions(permissions, ['READ:DEVICE:PROD'])
  const alertsShow =
    hasPermissions(permissions, ['READ:ALERTS:USAGE:IN_PROGRESS']) ||
    hasPermissions(permissions, ['READ:ALERTS:USAGE:CLOSED'])
  const usageShow = hasPermissions(permissions, ['READ:USAGE'])
  const newlyInstalledDevicesShow = hasPermissions(permissions, ['ACCOUNT:ADMIN:SMARTFLOW'])
  const newlyInstalledDevices = filterNewlyInstalledDevices(devices)

  const dUuidSet = useMemo(
    () => new Set(devices.map((d) => d.dUuid)),
    [devices],
  )

  const filteredQueue = useMemo(
    () => queue.filter((q) => dUuidSet.has(q.dUuid)),
    [queue, dUuidSet],
  )

  return (
    <div className="home">
      <div className="row mb-4">
        <div className={statusShow ? 'col-xl-8' : 'col-xl-6'}>
          {statusShow ? (
            <DeviceStatusComponent />
          ) : devicesShow ? (
            <UserDeviceListComponent />
          ) : null}
        </div>
        <div className={statusShow ? 'col-xl-4' : 'col-xl-6'}>
          {alertsShow ?
            <AlertStatusComponent
              filteredQueue={filteredQueue}
            />
            : null}
          {newlyInstalledDevices.length > 0 && newlyInstalledDevicesShow && (
            <NewlyInstalledDevicesComponent devices={newlyInstalledDevices} />
          )}
        </div>
      </div>
      <div className="row mb-4">
        <div className="col">{usageShow ? <CurrentWaterUsageComponent /> : null}</div>
      </div>
    </div>
  )
}

export default HomeOld
